import React from 'react';
import {graphql} from 'gatsby';
import {VideoCarouselFragment} from '@graphql-types';
import {parseUrl} from 'query-string';

import * as styles from './videoCarousel.module.scss';

const youtubeVideoId = (url: string) => {
  const pairs = parseUrl(url);

  return pairs.query.v || '';
};

const parseEmbedUrl = (html: string) => {
  const matches = html.match(/src="(.*?)"/);

  if (matches.length > 1) {
    return matches[1];
  }

  return '';
};

const VideoCarousel = (props: VideoCarouselFragment) => {
  return (
    <div id="member-testimonials" className={styles.wrapper}>
      <div
        className={styles.header}
        dangerouslySetInnerHTML={{__html: props.primary.heading.html}}
      />
      <div className={styles.videoList}>
        {props.items.map((item, i) => {
          return (
            <div className={styles.video} key={i}>
              <div className={styles.youtubePlayerContainer}>
                <iframe
                  className={styles.youtubePlayer}
                  src={parseEmbedUrl(item.video.html)}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen={true}
                />
              </div>
              <div
                className={styles.quote}
                dangerouslySetInnerHTML={{__html: item.video_description.html}}
              />
            </div>
          );
        })}
      </div>
      <div
        className={styles.ctaWrapper}
        dangerouslySetInnerHTML={{__html: props.primary.cta_content.html}}
      />
    </div>
  );
};

export default VideoCarousel;

export const query = graphql`
  fragment videoCarousel on PrismicPageDataBodyVideoCarousel {
    id
    slice_type
    primary {
      heading {
        html
      }
      cta_content {
        html
      }
    }
    items {
      video {
        html
      }
      video_description {
        html
      }
    }
  }
`;
